<template>
    <div>
        <div v-if="isLoading" class="text-center">
            <v-progress-circular indeterminate></v-progress-circular>
        </div>

        <div v-else>
            <v-simple-table class="elevation-1">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th style="width: 80px;"></th>
                            <th>Käyttäjä</th>
                            <th>Kuitattu</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in acknowledgments" :key="item.id">
                            <td>
                                <v-icon v-if="acknowledged" color="success">
                                    {{ icons.mdiCheck }}
                                </v-icon>
                                <v-icon v-else color="error">
                                    {{ icons.mdiAlertCircleOutline }}
                                </v-icon>
                            </td>
                            <td>{{ item.user_name }}</td>
                            <td>
                                <span v-if="acknowledged">
                                    {{ formatDate(item.acknowledged_at) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <!-- Pagination -->
            <div class="d-flex justify-center mt-4" v-if="totalItems > pageSize">
                <v-pagination v-model="currentPage" :length="Math.ceil(totalItems / pageSize)"
                    :total-visible="7"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api";
import adminApi from "@/api/admin";
import { mdiAlertCircleOutline, mdiCheck } from "@mdi/js";


export default {
    props: {
        targetType: {
            type: [String, Number],
            required: true,
        },
        targetId: {
            type: [String, Number],
            required: true,
        },
        acknowledged: {
            type: Boolean,
            required: true,
        },
        version: {
            type: [String, Number],
            default: null,
        },
    },
    setup(props) {
        const isLoading = ref(true);
        const acknowledgments = ref([]);
        const totalItems = ref(0);
        const currentPage = ref(1);
        const pageSize = 50;

        const loadAcknowledgments = async () => {
            if (!props.targetId) return;

            isLoading.value = true;
            try {

                const response = await adminApi.getAcknowledgments(
                    props.targetType,
                    props.targetId,
                    currentPage.value,
                    props.acknowledged,
                    pageSize,
                    props.version,
                );

                if (response.ok) {
                    acknowledgments.value = response.data.results;
                    totalItems.value = response.data.count;
                } else {
                    console.error("Failed to load acknowledgments:", response.error);
                }
            } catch (error) {
                console.error("Error loading acknowledgments:", error);
            } finally {
                isLoading.value = false;
            }
        };

        const formatDate = (dateString) => {
            if (!dateString) return "";
            const date = new Date(dateString);
            return date.toLocaleDateString("fi-FI") + " " + date.toLocaleTimeString("fi-FI", {
                hour: "2-digit",
                minute: "2-digit",
            });
        };

        watch(currentPage, () => {
            loadAcknowledgments();
        });

        watch(() => props.version, () => {
            currentPage.value = 1;
            loadAcknowledgments();
        });

        onMounted(() => {
            loadAcknowledgments();
        });

        return {
            isLoading,
            acknowledgments,
            totalItems,
            currentPage,
            loadAcknowledgments,
            formatDate,
            pageSize,
            icons: {
                mdiAlertCircleOutline,
                mdiCheck,
            },
        };
    },
};
</script>
